import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { usePriceDetailsStore } from '../../infrastructure/price-details/store';
import { useCommonDependency } from '@/scopes/common/infrastructure/dependencies/common';

export function usePriceDetails() {
  const { isLoading, isFetching, error, data } = usePriceDetailsQuery();

  return {
    isLoading,
    isFetching,
    error,
    priceDetails: data,
  };
}

export function usePriceDetailsQuery() {
  const priceDetailsQueryParams = usePriceDetailsStore();
  const priceDetailsApiClient = useCommonDependency('priceDetailsApiClient');

  return useQuery({
    queryKey: ['price-details', JSON.stringify(priceDetailsQueryParams)],
    queryFn: () => priceDetailsApiClient.getPriceDetails(priceDetailsQueryParams),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    staleTime: 60 * 60000, // Set the cache duration in milliseconds (1 hour in this example),
  });
}

export function usePriceDetailsSelect() {
  const { setPriceDetailsQueryParams } = usePriceDetailsStore();

  return {
    setPriceDetailsQueryParams,
  };
}
